import { render, staticRenderFns } from "./TrafficDemographics.vue?vue&type=template&id=28f9c13e&scoped=true&"
import script from "./TrafficDemographics.vue?vue&type=script&lang=js&"
export * from "./TrafficDemographics.vue?vue&type=script&lang=js&"
import style0 from "./TrafficDemographics.vue?vue&type=style&index=0&id=28f9c13e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9c13e",
  null
  
)

export default component.exports